import routerUtils from "@/router/routerUtils";
import { RouteLocationNormalized } from "vue-router";
import AbschlussHG from "@/views/hg/views/AbschlussHG.vue";
import IhreDatenHG from "@/views/hg/views/IhreDatenHG.vue";
import TarifHG from "@/views/hg/views/TarifHG.vue";
import BasisdatenHG from "@/views/hg/views/BasisdatenHG.vue";
import BestaetigungHG from "@/views/hg/views/BestaetigungHG.vue";

const { pruefeDatenVorhanden } = routerUtils();

export default [
  {
    path: "",
    name: "HG_Basisdaten_Makler",
    component: BasisdatenHG,
    props: (route: RouteLocationNormalized): any => ({
      isMakler: true,
      anfrageId: route.query.anfrageId,
    }),
    meta: {
      title: "Haus- und Grundbesitzerhaftpflicht - Basisdaten | GEV-Versicherung",
    },
  },
  {
    path: "vergleich",
    name: "HG_Tarif_Makler",
    component: TarifHG,
    props: { isMakler: true },
    meta: {
      title: "Haus- und Grundbesitzerhaftpflicht - Tarif | GEV-Versicherung",
    },
    beforeEnter: pruefeDatenVorhanden("/makler/hg", "NEU"),
  },
  {
    path: "ihre-daten",
    name: "HG_IhreDaten_Makler",
    component: IhreDatenHG,
    props: { isMakler: true },
    meta: {
      title: "Haus- und Grundbesitzerhaftpflicht - Ihre Daten | GEV-Versicherung",
    },
    beforeEnter: pruefeDatenVorhanden("/makler/hg", "NEU"),
  },
  {
    path: "abschluss",
    name: "HG_Abschluss_Makler",
    component: AbschlussHG,
    props: { isMakler: true },
    meta: {
      title: "Haus- und Grundbesitzerhaftpflicht - Zusammenfassung und Abschluss | GEV-Versicherung",
    },
    beforeEnter: pruefeDatenVorhanden("/makler/hg", "NEU"),
  },
  {
    path: "bestaetigung",
    name: "HG_Bestaetigung_Makler",
    component: BestaetigungHG,
    props: { isMakler: true },
    meta: {
      title: "Haus- und Grundbesitzerhaftpflicht - Vielen Dank | GEV-Versicherung",
    },
    beforeEnter: pruefeDatenVorhanden("/makler/hg"),
  },
];
